<template>
  <template v-if="info.status === 'edit'">
    <div style="padding-bottom: 20px">
      <a-upload-dragger
        :action="uploadPath"
        :file-list="fileList"
        :headers="headers"
        @change="onChange"
        :multiple="widget.multi"
      >
        <p class="ant-upload-drag-icon">
          <sc-icon type="InboxOutlined" />
        </p>
        <p class="ant-upload-text">点击或将文件拖拽此处上传</p>
        <p class="ant-upload-hint"></p>
      </a-upload-dragger>
    </div>
  </template>
  <div v-else>
    <div class="show-box">
      <a-tooltip :title="file" v-for="(file, index) in files" :key="index">
        <sc-icon
          type="FileTextOutlined"
          style="color: #1da57a; font-size: 50px"
          @click="open(file)"
        />
      </a-tooltip>
    </div>
  </div>
</template>

<script lang="ts">
import { definedWidgetMeta } from '@/components/business/crud/widgets/widgetManager';

export const meta = definedWidgetMeta({
  size: { edit: 'large', show: 'small' },
});
</script>

<script lang="ts" setup>
import { computed, defineProps, ref } from 'vue';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import { ScForm } from '@/models/ScForm';
import { UploadChangeParam, UploadProps } from 'ant-design-vue';
import config from '@/config';
import { tokenManager } from '@/util/token';
import { FileFieldType } from '@/components/business/crud/interface/FieldType';

const props = defineProps<{
  propName: string;
  widget: FileFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();

const uploadPath = config.uploadApiPath;
const uploadList = ref<Exclude<UploadProps['fileList'], undefined>>([]);
const headers = {
  ...tokenManager.get(),
};

const fileList = computed(() => {
  const res: Exclude<UploadProps['fileList'], undefined> = (
    data.value[props.propName]?.split(',') || []
  )
    .filter((i) => i)
    .map((item) => {
      return {
        uid: item,
        name: item,
        status: 'done',
        url: config.uploadPath + item,
      };
    });
  return res.concat(...uploadList.value);
});

function onChange(info: UploadChangeParam) {
  uploadList.value = info.fileList.filter((file) => file.status !== 'done');
  const file = info.file;
  if (file.status === 'removed') {
    data.value[props.propName] = (data.value[props.propName]?.split(',') || [])
      .filter((i) => i)
      .filter((id: string) => id !== file.uid)
      .join(',');
  } else if (file.status === 'done') {
    data.value[props.propName] = [
      ...(data.value[props.propName]?.split(',') || []),
      file.response.data.path,
    ].join(',');
  }
}

const files = computed(() => {
  return (data.value[props.propName]?.split(',') || [])
    .filter((i) => i)
    .map((i) => config.uploadPath + i);
});

function open(file: string) {
  window.open(file, '_blank');
}
</script>

<style lang="scss" scoped>
.view {
  height: 100%;
  padding-left: 12px;
}

.show-box {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;

  .img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    margin: 0 5px 5px 0;
    cursor: pointer;
  }
}
</style>
